export const renderAdditionalMessage = ({
    additional_message_icon,
    additional_message,
    additional_message_link
}) => {
    if (!additional_message && !additional_message_link) {
        return ''
    }

    let additionalMessageFinal = ''

    if (additional_message) {
        let renderIcon = ''
        if (additional_message_icon) {
            renderIcon = `<nb-icon icon="${additional_message_icon}" class="additionalMsgIcon"></nb-icon>`
        }

        additionalMessageFinal = `<p class="cb-warn t-sm-500-sl">
            ${renderIcon}
            ${additional_message}</p>`
    }

    const hasAdditionalMessageLink =
        additional_message_link && additional_message_link.link && additional_message_link.label

    if (!hasAdditionalMessageLink) {
        return additionalMessageFinal
    }

    return (
        additionalMessageFinal +
        `<nb-link
            link='${additional_message_link.link}'
            color="${additional_message_link.color}"
            size="${additional_message_link.size}"
            seo_label="${additional_message_link.seo_label}">
            ${additional_message_link.label}
        </nb-link>`
    )
}
